"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomEdge = void 0;
var react_1 = __importDefault(require("react"));
var react_flow_renderer_1 = require("react-flow-renderer");
/**
 * Custom edge component with label positioned at 30% of edge length
 * Renders only path (labels rendered separately by LabelEdge component)
 */
exports.CustomEdge = function (_a) {
    var id = _a.id, sourceX = _a.sourceX, sourceY = _a.sourceY, targetX = _a.targetX, targetY = _a.targetY, sourcePosition = _a.sourcePosition, targetPosition = _a.targetPosition, _b = _a.style, style = _b === void 0 ? {} : _b, markerEnd = _a.markerEnd;
    var edgePath = react_flow_renderer_1.getBezierPath({
        sourceX: sourceX,
        sourceY: sourceY,
        sourcePosition: sourcePosition,
        targetX: targetX,
        targetY: targetY,
        targetPosition: targetPosition,
    });
    return (react_1.default.createElement("path", { id: id, style: __assign(__assign({}, style), { pointerEvents: "none" }), className: "react-flow__edge-path", d: edgePath, markerEnd: markerEnd }));
};
